var Accordion = /** @class */ (function () {
    function Accordion(_a) {
        var details = _a.details, content = _a.content;
        var _this = this;
        this.animation = null;
        this.isClosing = false;
        this.isExpanding = false;
        this.details = details;
        this.content = content;
        this.summary = this.details.querySelector('summary');
        this.summary.addEventListener('click', function (e) { return _this.onClick(e); });
    }
    Accordion.prototype.onClick = function (e) {
        e.preventDefault();
        this.details.style.overflow = 'hidden';
        if (this.isClosing || !this.details.open) {
            this.open();
        }
        else if (this.isExpanding || this.details.open) {
            this.shrink();
        }
    };
    Accordion.prototype.shrink = function () {
        var _this = this;
        this.isClosing = true;
        var startHeight = "".concat(this.details.offsetHeight, "px");
        var endHeight = "".concat(this.summary.offsetHeight, "px");
        if (this.animation) {
            this.animation.cancel();
        }
        this.animation = this.details.animate({
            height: [startHeight, endHeight],
        }, {
            duration: 300,
            easing: 'linear',
        });
        this.animation.onfinish = function () { return _this.onAnimationFinish(false); };
        this.animation.oncancel = function () { return (_this.isClosing = false); };
    };
    Accordion.prototype.open = function () {
        var _this = this;
        this.details.style.height = "".concat(this.details.offsetHeight, "px");
        this.details.open = true;
        window.requestAnimationFrame(function () { return _this.expand(); });
    };
    Accordion.prototype.expand = function () {
        var _this = this;
        this.isExpanding = true;
        var startHeight = "".concat(this.details.offsetHeight, "px");
        var endHeight = "".concat(this.summary.offsetHeight + this.content.offsetHeight, "px");
        if (this.animation) {
            this.animation.cancel();
        }
        this.animation = this.details.animate({
            height: [startHeight, endHeight],
        }, {
            duration: 400,
            easing: 'ease-out',
        });
        this.animation.onfinish = function () { return _this.onAnimationFinish(true); };
        this.animation.oncancel = function () { return (_this.isExpanding = false); };
    };
    Accordion.prototype.onAnimationFinish = function (open) {
        this.details.open = open;
        this.animation = null;
        this.isClosing = false;
        this.isExpanding = false;
        this.details.style.height = this.details.style.overflow = '';
    };
    return Accordion;
}());
export { Accordion };
